module.exports = __webpack_public_path__ + "static/media/tribes.e18d8a7b.png";